import { render, staticRenderFns } from "./vipService.vue?vue&type=template&id=5b53c146&scoped=true"
import script from "./vipService.vue?vue&type=script&lang=js"
export * from "./vipService.vue?vue&type=script&lang=js"
import style0 from "./vipService.vue?vue&type=style&index=0&id=5b53c146&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b53c146",
  null
  
)

export default component.exports